import React, { Component } from 'react';
import { Grid, Label, Segment, Item } from 'semantic-ui-react';
import { Button, Form, Input, Dropdown, Checkbox } from 'formik-semantic-ui';
import * as Yup from 'yup';
import { servicesAPI } from '../../_services';
import { history } from '../../_helpers';

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: this.props.user,
      getroleobj: {}
    };
  }
  static defaultProps = {
    user: {
      firstName: '',
      lastName: '',
      userName: '',
      email: '',
      userRole: '',
      userStatus: true,
      userPassword: ''
    }
  };

  _handleSubmit = (values, formikApi) => {
    values = {
      ...values,
      id: this.props.match.params._id
    };
    //console.log(values, formikApi);return true;
    // Make API Call
    servicesAPI.update(values).then(
      user_detail => {
        const { from } = {
          from: { pathname: '/admin/user/' + user_detail.id }
        };
        history.push(from);
        //console.log(user_detail.id);
        formikApi.setSubmitting(false);
        if (user_detail.type === 'user_profile') {
          formikApi.setStatus({ success: user_detail.message });
        }
        //console.log(user_detail);
      },
      error => {
        formikApi.setSubmitting(false);
        formikApi.setStatus({ error: error });
      }
    );
  };
  componentDidMount() {
    servicesAPI
      .getById(this.props.match.params._id)
      .then(user => this.setState({ user }));
    servicesAPI.Roleservice().then(getroleobj => {
      this.setState({ getroleobj: getroleobj });
    });
  }

  render() {
    const { user, getroleobj } = this.state;
    const initialize_form = {
      ...user,
      typeUserForm: 'UserProfile'
    };
    const userRole = Object.values(getroleobj).map(function(obj) {
      return {
        key: obj.id,
        text: obj.role,
        value: obj.id
      };
    });

    return (
      <div>
        <Grid>
          <Grid.Column stretched width={16}>
            <Segment>
              <Item.Group>
                <Item>
                  <Item.Content>
                    <Item.Header as="a">
                      {user.firstName} {user.lastName}
                    </Item.Header>
                    <Item.Meta>{user.userName}</Item.Meta>
                  </Item.Content>
                </Item>
              </Item.Group>
              <Form
                ignoreLoading
                initialValues={initialize_form}
                enableReinitialize
                onSubmit={this._handleSubmit}
                validationSchema={Yup.object().shape({
                  firstName: Yup.string()
                    .max(40, 'Please enter no more than 40 characters')
                    .required('Please enter your first name')
                    .nullable(),
                  lastName: Yup.string()
                    .required('Please enter your first name')
                    .nullable(),
                  userName: Yup.string()
                    .required('Please enter your user name')
                    .nullable(),
                  email: Yup.string()
                    .email('E-mail is not valid!')
                    .required('E-mail is required!')
                    .nullable()
                })}
              >
                {({ errors, status, touched, isSubmitting }) => (
                  <div>
                    <Form.Children>
                      {status && status.error ? (
                        <Label basic color={'red'} className={'red'}>
                          {status.error}
                        </Label>
                      ) : (
                        ''
                      )}
                      {status && status.success ? (
                        <Label basic color={'green'} className={'green'}>
                          {status.success}
                        </Label>
                      ) : (
                        ''
                      )}

                      <Form.Group widths={2}>
                        <Input
                          inputProps={{
                            icon: 'user plus',
                            iconPosition: 'left',
                            placeholder: 'First name'
                          }}
                          label="First Name"
                          name="firstName"
                        />
                        {/* <input type="hidden" name="id" value={user.id}  /> */}
                        <Input
                          inputProps={{
                            icon: 'user plus',
                            iconPosition: 'left',
                            placeholder: 'Last name'
                          }}
                          label="Last Name"
                          name="lastName"
                        />
                      </Form.Group>
                      <Form.Group widths={2}>
                        <Input
                          inputProps={{
                            icon: 'user',
                            iconPosition: 'left',
                            placeholder: 'User name'
                          }}
                          label="User Name"
                          name="userName"
                        />

                        <Input
                          inputProps={{
                            icon: 'mail',
                            iconPosition: 'left',
                            placeholder: 'email'
                          }}
                          label="Email"
                          name="email"
                        />
                      </Form.Group>
                      <Form.Group widths={2}>
                        <Form.Field
                          placeholder="Select Role"
                          name="userRole"
                          label="User Role"
                          control={Dropdown}
                          fluid
                          selection
                          onChange={this.handleChange}
                          options={userRole}
                          value={this.state.user}
                        />

                        <Input
                          inputProps={{
                            type: 'password',
                            icon: 'key',
                            iconPosition: 'left',
                            placeholder: 'Password'
                          }}
                          label="Password"
                          name="userPassword"
                        />
                      </Form.Group>
                      <Form.Group widths={2}>
                        <Checkbox slider label="Is Active" name="userStatus" />
                      </Form.Group>
                      <Button.Submit
                        primary
                        type="submit"
                        loading={isSubmitting}
                      >
                        Update Profile
                      </Button.Submit>
                    </Form.Children>
                  </div>
                )}
              </Form>
            </Segment>
          </Grid.Column>
        </Grid>
      </div>
    );
  }
}

export { UserProfile };
